import { render, staticRenderFns } from "./NotificationSettings.vue?vue&type=template&id=2cc8b910&scoped=true"
import script from "./NotificationSettings.vue?vue&type=script&lang=js"
export * from "./NotificationSettings.vue?vue&type=script&lang=js"
import style0 from "./NotificationSettings.vue?vue&type=style&index=0&id=2cc8b910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc8b910",
  null
  
)

export default component.exports